import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        setIsLoading(true);
        const res = await fetch('/api/posts');
        if (!res.ok) {
          throw new Error(`Failed to fetch posts: ${res.status}`);
        }
        const data = await res.json();
        setPosts(data || []);
      } catch (err) {
        setError(err.message || 'Unknown error');
      } finally {
        setIsLoading(false);
      }
    };
    fetchPosts();
  }, []);

  if (isLoading) {
    return (
      <div className="text-white flex justify-center items-center" style={{ minHeight: '60vh' }}>
        <h2>Loading posts…</h2>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-white flex justify-center items-center" style={{ minHeight: '60vh' }}>
        <h2>Error: {error}</h2>
      </div>
    );
  }

  if (!posts.length) {
    return (
      <div className="text-white flex justify-center items-center" style={{ minHeight: '60vh' }}>
        <h2>No blog posts yet.</h2>
      </div>
    );
  }

  return (
    <div className="bg-color-dark text-white px-24 py-48">
      <div className="mx-auto" style={{ maxWidth: 1200 }}>
        <h1 className="text-center text-48px mb-24">Blog</h1>
        <p className="text-center text-18px mb-48 mx-auto" style={{ maxWidth: 640 }}>
          Thoughts, updates, and insights from the Beck Develops venture studio.
        </p>

        <div className="grid gap-24">
          {posts.map((post) => (
            <div key={post.post_id} className="bg-accent-dark br-5 p-24">
              <Link to={`/blog/${post.slug}`}>
                <h2 className="text-white text-32px mb-12 hover:text-secondary-dark">{post.title}</h2>
              </Link>
              {post.user && (
                <p className="text-primary-dark text-14px mb-16">
                  By {post.user.firstName} {post.user.lastName} • {post.user.username}
                </p>
              )}
              <div className="mt-16">
                <Link to={`/blog/${post.slug}`}>
                  <button className="px-24 py-12 primary-color-dark no-border bold br-5 nav-button">
                    Read More →
                  </button>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blog;
